@if (loading) {
  <loading class="pos-abs vh-center"></loading>
}
@if (!article && !loading) {
  <app-product-view [user]="user" [product]="product" [numberOfProductsInCart]="numberOfProductsInCart" [productInCart]="productInCart" [experiments]="experiments" [isAddRemovePending]="isAddRemovePending" (back)="back()" (removeFromCart)="removeFromCart($event)" (buyNow)="handleBuyNow($event)"></app-product-view>
}
@if (article && !loading) {
  <app-article-view [user]="user" [article]="article" [product]="product" [numberOfProductsInCart]="numberOfProductsInCart" [productInCart]="productInCart" [experiments]="experiments" [isAddRemovePending]="isAddRemovePending" (back)="back()" (removeFromCart)="removeFromCart($event)" (buyNow)="handleBuyNow($event)"></app-article-view>
}
